import React from 'react';
import { Typography, Skeleton, Grid } from '@mui/material';
import { camelize } from 'helpers/syntaxHelper';
import { MantyStatus } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import { getPositionValue } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/gridHelpers';
import { NonRecurrentHypothesisTypePerMantyStatus } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/HypothesisTypePerMantyStatus/helpers/types';
import { HypothesisTypeSelector } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/HypothesisTypePerMantyStatus/HypothesisTypeSelector';
import Flex from 'ui/Flex/Flex';
import { NonRecurrentHypothesisType } from './helpers/constants';

const HypothesisTypeItem = ({
    status,
    isLoading,
    values,
    handleChange,
}: {
    status: MantyStatus;
    isLoading: boolean;
    values: NonRecurrentHypothesisTypePerMantyStatus;
    handleChange: (key: string, newValue: NonRecurrentHypothesisType) => void;
}) => {
    const camelKey = camelize(status);
    return (
        <Grid container item xs={3}>
            <Flex
                justify="space-between"
                m={1}
                p={1}
                sx={{ width: '100%', mr: '1em' }}
            >
                <Flex align="center" sx={{ h: '100%' }}>
                    <Typography variant="body1SemiBold">
                        {getPositionValue(status)}
                    </Typography>
                </Flex>
                {isLoading ? (
                    <Skeleton
                        variant="rectangular"
                        sx={{ width: '30%', height: '2em' }}
                    />
                ) : (
                    <HypothesisTypeSelector
                        currentType={values[camelKey]}
                        onChange={(newType) => handleChange(camelKey, newType)}
                    />
                )}
            </Flex>
        </Grid>
    );
};

export default HypothesisTypeItem;
